module.exports = __webpack_public_path__ + "img/MaterialSymbolsClose.d3972b98.svg";